const dataBlog = [
  {
    img: "common-types.svg",
    title: "مقیاس‌پذیری",
    desc: "با تغییر نیازهای کسب‌وکارتان هیچ محدودیتی برای افزایش یا کاهش میزان منابع مورد تقاضای شما وجود ندارد! در ابر «آبالون»، ارتقای حافظه، میزان فضای ذخیره‌سازی، افزایش تعداد پردازنده‌ها و… برای پشتیبانی از کاربران بیشتر، فقط در عرض چند ثانیه بدون هیچ‌گونه وقفه عملیاتی امکان‌پذیر است و این ویژگی، سرورهای ابری «آبالون» را به گزینه‌ای ایده‌آل برای شرکت‌هایی تبدیل می‌کند که در حال رشد هستند.",
    alt: "مقیاس‌پذیری",
  },
  {
    img: "Google.svg",
    title: "اطمینان بالا",
    desc: "سرورهای ابری اتصالی مطمئن، بدون وقفه و با سرعت بالا را برای کاربران فراهم می‌کنند. این سرورها برای به اشتراک گذاشتن قدرت پردازش خود توسط فناوری موسوم به رایانش ابری در استخری از منابع به یکدیگر متصل می‌شوند، در نتیجه مجموعه‌هایی که از زیرساخت‌های ابری برای ارائه خدمات خود استفاده ‌می‌کنند می توانند پایداری و اطمینان صد در صدی را تجربه کنند.",
    alt: "اطمینان بالا",
  },
  {
    img: "everything.svg",
    title: "بهینه‌سازی منابع",
    desc: "با استفاده از سرویس‌های ابری، علاوه بر بهینه‌سازی منابع مالی خود جهت خرید سخت‌افزار و فرآیند پیچیده نگهداری از آن‌ها، تمرکز تیم زیرساخت خود را بر هسته اصلی کسب‌وکار معطوف خواهید کرد و آن‌ها دیگر درگیر مسائل نصب و راه‌اندازی و نگهداری زیرساخت‌های پردازشی نخواهند شد.",
    alt: "بهینه‌سازی منابع",
  },
  {
    img: "python.svg",
    title: "امنیت پیشرفته",
    desc: "با تغییر نیازهای کسب‌وکارتان هیچ محدودیتی برای افزایش یا کاهش میزان منابع مورد تقاضای شما وجود ندارد! در ابر «آبالون»، ارتقای حافظه، میزان فضای ذخیره‌سازی، افزایش تعداد پردازنده‌ها و… برای پشتیبانی از کاربران بیشتر، فقط در عرض چند ثانیه بدون هیچ‌گونه وقفه عملیاتی امکان‌پذیر است و این ویژگی، سرورهای ابری «آبالون» را به گزینه‌ای ایده‌آل برای شرکت‌هایی تبدیل می‌کند که در حال رشد هستند.",
    alt: "وبینار آبالون",
  },
  {
    img: "top-ways.svg",
    title: "انعطاف‌پذیری",
    desc: "با منابعی که نیاز دارید، سریع و آسان شروع کنید! سپس با توجه به نیاز کسب‌وکارتان، تنها با چند کلیک افزایش یا کاهش منابع دهید! بعلاوه، سرورهای ابری می‌توانند با تغییرات سریع برای نیازهای مختلف، بارهای کاری متنوعی را در خود جای دهند. در ابر «آبالون» می‌توانید به راحتی، ویژگی‌های سرور ابری خود را با استفاده از داشبورد مدیریت ابری اختصاصی خود کنترل کنید.",
    alt: "انعطاف‌پذیری",
  },
  {
    img: "Google.svg",
    title: "انعطاف‌پذیری",
    desc: "با منابعی که نیاز دارید، سریع و آسان شروع کنید! سپس با توجه به نیاز کسب‌وکارتان، تنها با چند کلیک افزایش یا کاهش منابع دهید! بعلاوه، سرورهای ابری می‌توانند با تغییرات سریع برای نیازهای مختلف، بارهای کاری متنوعی را در خود جای دهند. در ابر «آبالون» می‌توانید به راحتی، ویژگی‌های سرور ابری خود را با استفاده از داشبورد مدیریت ابری اختصاصی خود کنترل کنید.        ",
    alt: "انعطاف‌پذیری",
  },
];
const benefits = [
  {
    title: "قابلیت انتخاب سطح سرویس",
    logo: "sla.svg",
  },
  {
    title: "پشتیبانی 365 / 24 / 7",
    logo: "support.svg",
  },
  {
    title: "زیرساخت‌های ایمن",
    logo: "infrustructure.svg",
  },
  {
    title: "داشبورد ابری یکپارچه و جامع ",
    logo: "dashboard.svg",
  },
  {
    title: "کیفیت بالای CPU، RAM و حافظه‌ها",
    logo: "hq.svg",
  },
  {
    title: "پشتیبانی فنی رایگان",
    logo: "freeSupport.svg",
  },
];

const questions = [
  {
    title: "«سرویس‌های مدیریت‌شده» چیست؟",
    answer:
      "سرویس مدیریت شده، خدمتی است که در کنار هریک از محصولات ابری قابل استفاده است و طی آن نیروهای فنی و متخصص آبالون به تیم فنی شما اضافه خواهند شد تا مدیریت، نگهداری و پشتیبانی سرویس‌های مورد استفاده شما را برعهده بگیرند.",
  },
  {
    title: "هزینه «سرویس‌های مدیریت‌شده» چقدر است؟",
    answer:
      "چیزی به نام قیمت‌گذاری استاندارد برای سرویس‌های مدیریت‌شده وجود ندارد! علت این امر آن است که راهکار هریک از مخاطبان اختصاصی بوده و از پیش قابل قیمت‌گذاری نیست. اما نکته‌ای که اهمیت دارد آن است که فرآیند مشخصی برای قیمت‌گذاری عادلانه وجود داشته باشد تا طی فرآیند با آگاهی مخاطبان، قیمت‌گذاری درست انجام شود.",
  },
  {
    title: "مزایای استفاده از «سرویس‌ مدیریت‌ شده» چیست؟",
    answer:
      "مزیت اصلی سرویس‌ مدیریت‌ شده آرامش خاطر و بهینه‌سازی محسوس هزینه‌های کلی IT در یک مجموعه است. با استفاده از سرویس مدیریت شده این امکان را دارید تا از دانش متخصصین با پایین‌ترین هزینه و کمترین خطا استفاده کنید. با استفاده از این سرویس کیفیت بهره‌برداری از زیرساخت ابری خود را بهبود خواهید بخشید و پایه‌های امنیتی داده‌های خود را تا سطح بالایی تامین خواهید کرد. علاوه بر موارد فوق با این سرویس می‌توانید هر زمان که به پشتیبانی IT نیاز داشتید، نیاز خود را به سرعت مطرح کنید و پاسخ اختصاصی خود را دریافت کنید.",
  },
  {
    title: "تفاوت «سرویس‌های مدیریت‌ شده» با خدمات مشاوره چیست؟",
    answer:
      "متخصصان در هر دو حوزه به شما کمک می‌کنند تا بهترین فناوری کسب‌وکار را برای حمایت از آینده شرکت خود تعیین کنید و هر دوی آن‌ها فناوری مورد نظر را برای شما پیاده‌سازی خواهند کرد. تفاوت آن‌ها به این صورت است که یک مشاور در هنگام پیاده‌سازی و پس از راه‌اندازی سرویس مسولیتی ندارد اما یک ارائه‌دهنده خدمات مدیریت شده، یک رابطه بلندمدت ایجاد می‌کند تا مطمئن باشد که سرویس‌های شما به درستی پیاده‌سازی می‌شوند و عملکرد مناسبی دارند.",
  },
  {
    title: "مدیریت سرویس‌ها برای کدام محصولات انجام می‌شود؟",
    answer:
      "مدیریت، رصد و کنترل سرویس‌ها در تمامی محصولاتی که آبالون ارائه می‌دهد قابل اجراست. همکاران ما شما را در استفاده از سرور ابری، دیتاسنتر ابری و هر محصول دیگری همراهی خواهند کرد و تمامی نیازمندی‌های شما را پوشش خواهند داد.",
  },
];

const customers = [
  {
    name: "سازمان‌های صنعتی",
    title: "مپنا",
    banner: "/industry.webp",
    logo: "/mapna-color.png",
    logo_gray: "/Mapna-gray.png",
    description:
      "مجموعه صنعتی گروه «مپنا» یکی از بزرگترین مجریان و پیمانکاران عمرانی، نیروگاهی، پزشکی و… در کشور است. با توجه به وسعت فعالیت‌ها و حجم پروژه‌های مپنا، قاعدتاً این مجموعه با چالش‌های بسیاری در دپارتمان فناوری اطلاعات خود از جمله پراکندگی تمرکز مواجه است که راهکارهای ابری می‌تواند به تنهایی پاسخی درخور به موانع استفاده از زیرساخت‌های سنتی‌اش باشد. محصول ویژه «سرویس‌های مدیریت شده» و راه‌حل‌های ابری «آبالون» توانسته است جای خود را در پی‌ریزی تصمیمات تجاری و بخش IT این مجموعه باز کند تا فرآیندهای انطباق، انعطاف‌پذیری و مقیاس‌پذیری منابع IT دیگر برای‌شان دغدغه‌ای نباشد.",
    banner_alt: "بیمه دی مشتری آبالون",
    logo_alt: "",
  },
  {
    name: "شرکت‌های بورسی",
    title: "اعتبار آی‌تی",
    banner: "/it.webp",
    logo: "/Etebar.png",
    logo_gray: "/Etebar-gary.png",
    description:
      "امروزه سازمان‌های زیادی مثل مجموعه «اعتبار آی.تی» نیازمند استفاده از راهکارهای یکپارچه‌ای هستند که انبوه اطلاعات پراکنده خود در شعب، دفاتر مختلف و داده‌های حاصل از تعامل با مشتریان را گردآوری، محاسبه و تجزیه و تحلیل کنند. شرکت فناوری اطلاعات اعتبار با رویکرد ارائه راهکارهای هوشمند به بازارهای مالی ، طراحی و تولید نرم افزارهایی با تعامل بهتر و بهینه که منطبق با نیازهای فعلی و آینده سازمان‌ها باشد، همراهی ابر «آبالون» با مجموعه «اعتبار آی.تی» در زمینه ارائه «سرویس‌های مدیریت‌ شده» رقم خورد تا این سازمان بزرگ، صرفاً به اهداف کلان IT و توسعه فرآیندهای خود فکر کند.",
    banner_alt: "دیجی نکست مشتری آبالون",
    logo_alt: "",
  },
  {
    name: "خدمات مالی و بیمه",
    title: "خدمات بیمه مهراندیش سینا",
    banner: "/bime.webp",
    logo: "/Sina.png",
    logo_gray: "/Sina- gray.png",
    description:
      "یکی از صنایعی که نیاز به همراهی و پشتیبانی اختصاصی و حرفه‌ای دارد، صنعت بیمه است که شرکت خدمات بیمه مهراندیش سینا یکی از شرکت‌های فعال در این حوزه است. این شرکت به علت ارائه خدمات بیمه به طیف گسترده‌ای از مخاطبان، نیازمند زیرساختی مطمئن برای ارائه خدمات بود که با کمک تیم متخصص آبالون توانست این هدف را محقق نماید. همکاران ما در راه‌اندازی سیستم‌های مورد نیاز این مجموعه در کنارشان بودند تا هرچه سریع‌تر زیرساخت مطمئن و قابل اتکایی برایشان فراهم گردد.",
    banner_alt: "ایریسا مشتری آبالون",
    logo_alt: "",
  },
  {
    name: "شرکت‌های تولید نرم‌افزار",
    title: "گروه نرم‌افزاری آفام",
    banner: "/software.webp",
    logo: "/afam-color.png",
    logo_gray: "/afam-gray.png",
    description:
      "گروه نرم‌افزاری «آفام» در حیطه توسعه سیستم‌های نرم‌افزاری فعالیت می‌کند و مانند تمام کسب‌وکارهایی که در صنعت فناوری اطلاعات کار می‌کنند بهینه‌سازی فرآیندهای زیرساختی و داخلی برای‌شان از اهمیت بالایی برخوردار است، طبیعتاً راه‌حل استفاده از «سرویس‌های مدیریت‌ شده» برای شرکت‌های نرم‌افزاری که بار کاری پیچیده‌ و حساسی دارند می‌تواند بسیار حیاتی و راه‌گشا باشد، ابر «آبالون» این افتخار را داشته تا با ارائه این سرویس همراه مطمئنی برای گروه «آفام» باشد.",
    banner_alt: "گروه مالی شهر مشتری آبالون",
    logo_alt: "",
  },
];
const uses = [
  {
    img: "focus.svg",
    title: "تمرکز (Focus)",
    desc: "توجه تیم زیرساخت خود را بر هسته اصلی کسب‌وکارتان معطوف کنید. آن‌ها دیگر درگیر مسائل نصب، راه‌اندازی و نگهداری زیرساخت‌های پردازشی نخواهند شد.",
  },

  {
    img: "exclusive.svg",
    title: "راهکارهای اختصاصی",
    desc: "پاسخ شما از روی دفترچه راهنما نیست! بلکه ما راهکارهای اختصاصی برای چالش‌های شما خلق می‌کنیم، می‌سازیم و به شما ارائه می‌دهیم.",
  },
  {
    img: "hardening.svg",
    title: "تقویت امنیتی (Hardening)",
    desc: "تیم عملیت ابر «آبالون» با تقویت ویژگی‌های امنیتی یا hardening به شما کمک می‌کند تا استانداردها و پروتکل‌های امنیتی ویژه‌ای را راه‌اندازی کنید.",
  },
  {
    img: "monitoring.svg",
    title: "مانیتورینگ پویا (proactive monitoring)",
    desc: "ابر «آبالون» با پیاده‌سازی سامانه‌های مانیتورینگ پیشرفته و به‌کارگیری فرآیندهای خودکار، در لایه اپلیکیشن نیز بر سلامت سرویس‌های شما نظارت خواهد کرد.",
  },
  {
    img: "devops.svg",
    title: "تیم عملیات متخصص",
    desc: "با تخصص‌های مختلف از جمله: DevOps Automation، Infrastructure Orchestration، مدیریت کانفیگ، Continuous Integration و… برای برطرف کردن مسائل‌تان، همراه شما هستیم.",
  },
  {
    img: "technical.svg",
    title: "تکنیکال اکانت منیجر اختصاصی",
    desc: "برای حل هر مسئله‌ای نقطه تعامل و ارتباط شما در «آبالون» با یک نفر خواهد بود و بین افراد مختلف جابجا نخواهد شد! این فرد از ابتدا تا انتهای مسیر همراه شما خواهد بود.",
  },
  {
    img: "agility.svg",
    title: "چابکی (Agility)",
    desc: "در توسعه محصولات، پیاده‌سازی معماری اپلیکیشن‌ها و راهکارهای مورد نیاز کسب‌وکارتان، تیم عملیات ابر «آبالون»، مشاور و همراه شماست تا چابکی بیشتری داشته باشید.",
  },
];
const ranges = [
  {
    title: "دامنه ارائه خدمات در سرویس‌های مدیریت‌شده ابر «آبالون»",
    items: [
      {
        name: "مدیریت زیرساخت",
        status: true,
      },
      {
        name: "نگهداری و پشتیبانی از نرم‌افزار",
        status: true,
      },
      {
        name: " مدیریت سیستم عامل",
        status: true,
      },
      {
        name: "پیکربندی سرویس‌های داخل سرور",
        status: true,
      },
      {
        name: "نصب و راه‌اندازی سرویس مورد نظر درون سرور ابری",
        status: true,
      },
      {
        name: "بازطراحی امنیتی",
        status: true,
      },
    ],
  },
  {
    title: "موارد زیر در سرویس‌های مدیریت‌شده ابر «آبالون» ارائه نمی‌شود",
    items: [
      {
        name: "کد نویسی و توسعه کد",
        status: false,
      },
      {
        name: "رفع باگ در کد",
        status: false,
      },
      {
        name: "برطرف کردن مشکل نرم‌افزارهای اختصاصی سازمان‌ها",
        status: false,
      },
    ],
  },
];

const mgUses = [
  {
    img: "monitor.svg",
    title: "نظارت و مشاهده",
    title_en: "(Monitoring & Observability)",
    desc: "برای حصول اطمینان از عملکرد ایمن بارهای کاری خود در زیرساخت ابری، مهم است در نظر بگیرید که چگونه می‌خواهید بر بهینه بودن بارهای کاری خود نظارت کنید. «سرویس‌های مدیریت‌ شده» با ارائه سیستم نظارتی پویا ریسک را کاهش، چابکی را افزایش و تجربه کاربری شما را بهبود می‌بخشد.  ابر «آبالون» با نظارت فعالانه 24x7x365 فعالیت‌ها، خطاها و حوادث، با اطمینان برای در دسترس بودن و انعطاف‌پذیری سرویس‌ها، قدرت عملیاتی را افزایش می‌دهد و از طریق اتوماسیون ویژه خود، حوادث را شناسایی کرده و بلافاصله به مشتریان اطلاع می‌دهد تا کیفیت ارائه خدمات خود را همراه با استانداردهای بالا حفظ کنند!",
  },

  {
    img: "centralized.svg",
    title: "مدیریت متمرکز عملیات",
    title_en: "(Centralized Operations Management)",
    desc: "انجام پیکربندی مطمئن و بهینه که سبب شود فرآیندها به صورت دقیق و بی وقفه ادامه یابند یکی از چالش‌های سازمان‌های بزرگ است که زیرساخت پیچیده‌ای دارند. همچنین انطباق داخلی و موفق بودن تست‌های کلیدی ارزیابی سیستم مواردی هستند که نیازمند متخصصان حرفه‌ای است تا زیرساخت به صورت دقیق پیاده‌سازی شود. سرویس مدیریت شده به مشتریان کمک می‌کند تا فضای خود را با ارائه مکانیسم‌های امنیتی تست‌شده با زمان‌بندی درست، بررسی‌های امنیتی و لایه‌های محافظت مدیریت‌ شده، پیکربندی کنند تا ایمن بمانند.",
  },
  {
    img: "configuration.svg",
    title: "پیکربندی، انطباق و ممیزی ",
    title_en: "(Configuration, Compliance & Auditing)",
    desc: "یکی از کلیدی‌ترین نیازهای شرکت‌ها و سازمان‌ها آن است که تمامی عملیات‌ها و فرآیندها به صورت یکپارچه و منظم انجام شوند. متمرکز بودن عملیات‌ها برای رشد و توسعه محصولات و پیشرفت تیم‌های فنی امری ضروری است. متخصصان ما با پیاده‌سازی و انجام تنظیمات زیرساخت به صورت یکپارچه این پارامتر کلیدی را برای شرکت‌ها به ارمغان خواهند آورد.",
  },
  {
    img: "enterprise.svg",
    title: "مدیریت و کنترل سازمانی",
    title_en: "(Enterprise Governance & Controls)",
    desc: "به منظور ارائه شفافیت سازمانی، ما گزارش‌هایی را از سرویس‌های مختلف ابر «آبالون» در این حوزه، برای خلاصه کردن معیارهای عملکرد کلیدی، از جمله یک پروپوزال با بینش‌های صرفه‌جویی در هزینه، و همچنین جزئیات دقیق خطاها و عملکرد ارائه می‌کنیم.",
  },
];

const operationSystems = [
  {
    name: "Content Management Systems",
    type: "4",
    apps: [
      {
        app: "Drupal",
        img: "Atlassia.svg",
      },
      {
        app: "Joomla",
        img: "joomla.svg",
      },
      {
        app: "Moodle",
        img: "Moodle.svg",
      },
      {
        app: "Confluence",
        img: "Wordmark.svg",
      },
    ],
  },
  {
    name: "Databases",
    type: "6",
    apps: [
      {
        app: "MariaDB",
        img: "MariaDB.svg",
      },
      {
        app: "MySQL",
        img: "MySQL.svg",
      },
      {
        app: "Neo4j",
        img: "Neo4j.svg",
      },
      {
        app: "PostgreSQL",
        img: "PostgreSQL.svg",
      },
      {
        app: "Redis",
        img: "redis.svg",
      },
      {
        app: "MongoDB",
        img: "MongoDB.svg",
      },
    ],
  },
  {
    name: "E-commerce & E-Learning",
    type: "4",
    apps: [
      {
        app: "osCommerce",
        img: "osCommerce.svg",
      },
      {
        app: "Plone",
        img: "Plone.svg",
      },
      {
        app: "Opencart",
        img: "Opencart.svg",
      },
      {
        app: "woocommerce",
        img: "woocommerce.svg",
      },
    ],
  },
  {
    name: "Application Frameworks",
    type: "4",
    apps: [
      {
        app: "Microsoft.net",
        img: "Microsoft.svg",
      },
      {
        app: "Elsstic",
        img: "Elsstic.svg",
      },
      {
        app: "iRedMail",
        img: "iRedMail.svg",
      },
      {
        app: "laravel",
        img: "laravel.svg",
      },
    ],
  },
  {
    name: "Infrastructure & Administrative",
    type: "4",
    apps: [
      {
        app: "Cpanel",
        img: "Cpanel.svg",
      },
      {
        app: "Django",
        img: "Django.svg",
      },
      {
        app: "Direct Admin",
        img: "Direct.svg",
      },
      {
        app: "prometheus",
        img: "prometheus.svg",
      },
    ],
  },
  {
    name: "Collaboration & Messaging",
    type: "6",
    apps: [
      {
        app: "REDMINE",
        img: "REDMINE.svg",
      },
      {
        app: "Rocket Chat",
        img: "Rocket.svg",
      },
      {
        app: "Bugzilla",
        img: "Bugzilla.svg",
      },
      {
        app: "Jira software",
        img: "Jira.svg",
      },
      {
        app: "Adobe Connect",
        img: "Adobe.svg",
      },
      {
        app: "Big Blue Button",
        img: "Big.svg",
      },
    ],
  },
];
export default {
  dataBlog,
  benefits,
  questions,
  uses,
  customers,
  operationSystems,
  ranges,
  mgUses,
};
